'use strict';

var TDChartNumberOfStopsFilterFactory = function TDChartNumberOfStopsFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandDateRangeFilterFactory', 'ServiceDemandClassFilterFactory', 'ServiceDemandTimeOfDayFilterFactory', 'ServiceDemandDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartNumberOfStopsFilter() {
    DemandFilter.call(this, 'service', 'thematic-demand-chart-service-number-of-stops');
    this.registerFilters(injectedFilters);
  }
  TDChartNumberOfStopsFilter.constructor = TDChartNumberOfStopsFilter;
  TDChartNumberOfStopsFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartNumberOfStopsFilter;
};
TDChartNumberOfStopsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = TDChartNumberOfStopsFilterFactory;